import styled from 'styled-components';
import { StyledComboboxContentHeaderProps } from './types';
import { baseContainer } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledComboboxContentHeader = styled.div<StyledComboboxContentHeaderProps>`
  ${baseContainer}
`;
